<template>
  <span :class="'badge bg-' + bg" ><slot></slot></span>
</template>

<script>
export default {
  name: "TagItem",
  props: ['bg'],

}
</script>
<style scoped>

span {
  margin-bottom: .3rem;
  padding: .4rem .6rem;
  margin-right: .3rem;
}

.bg-1{
  background-color: #1ec2b515;
  color: #1ec2b5;
}

.bg-2{
  background-color:#7234bd15;
  color: #7234bd;
}

.bg-3{
  background-color:#ef404e15;
  color: #ef404e;
}
</style>